__turbopack_context__.v({
  "select": "styles-module-scss-module__muFRmq__select",
});
